import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styles from './fieldset.module.scss'

const inlineClass = (inline) => (inline ? styles.fieldset['--inline'] : '')

const Fieldset = ({ inline = false, className = '', children, ...props }) => (
  <div
    className={`${styles.fieldset} ${styles['fieldset--inline']} ${className}`}
    {...props}
  >
    {children}
  </div>
)

Fieldset.propTypes = {
  inline: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
}

export default memo(Fieldset)
